var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"xrd-logo",attrs:{"src":require('../../assets/xroad7_logo.svg'),"height":"35","width":"132","max-height":"35","max-width":"132"},on:{"click":function($event){return _vm.home()}}})}
var staticRenderFns = []

export { render, staticRenderFns }